import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=374f3f00&scoped=true"
import script from "./AuthCard.vue?vue&type=script&lang=ts"
export * from "./AuthCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f3f00",
  null
  
)

export default component.exports